module.exports = __webpack_public_path__ + "static/media/Computer Programmer.847b8d95.jpg";